import { Component, OnInit } from '@angular/core';
import { Router, Params, ActivatedRoute } from '@angular/router';
import { UtilsService } from 'src/app/shared/utils.service';
import { AuthService } from 'src/app/auth/auth.service';
import { AlertDialogComponent } from 'src/app/shared/alert-dialog/alert-dialog.component';
import { User } from 'src/app/auth/user.model';
import {CardBillingComponent} from "../sponsoring/billing/card-billing/card-billing.component";
import {MatDialog} from "@angular/material/dialog";
import {DataService} from "../../shared/data.service";

declare let paypal: any;

@Component({
    selector: 'app-plans-billing',
    templateUrl: './plans-billing.component.html',
    styleUrls: ['./plans-billing.component.scss'],
    standalone: false
})
export class PlansBillingComponent implements OnInit {
  count: any;
  transaction: any;
  addScript: boolean = false;
  paypalload = false;
  user: User;

  paypalconfig = {
    env: 'sandbox',
    client: {
      sandbox: 'AfLwhc2UmYN5ZDlvYP1PUWMPvJ76PoQ5m9IBmjkMUJ8pSe9xAuKXY_WwkFVfwPq3gPmeoEEv6Scu-FOe',
      // production: 'AfGW-J6bzgmG72HAUg9T_nEV3fBBuEcSXlXFcKNCmLdxHSWG2It_vYO6EYNlhIGSBkoptFAHS8DmRGZO'
    },
    commit: true,
    payment: (data, actions) => {
      return actions.payment.create({
        payment: {
          transactions: [
            {amount: {total: this.count, currency: 'EUR'}}
          ]
        }
      });
    },
    onError:  (data, actions) => {
    },
    onAuthorize: (data, actions) => {
      const response = actions.payment.execute().then(function(payment) {
        return payment;
      });
      this.transaction = { data, response,
        Type: 1};
      return this.paypalBill();
    },
    style: {
      color: 'black',
      shape: 'rect',
      label: 'checkout',
      tagline: false,
      layout: 'vertical'
  },
  funding:
    {
        disallowed: [ ]
    },
  };
  totalPrice: any;
  subscriptionsPrice: any;
  subscriptionsNumber: any;
  planName: any;
  stars: any;
  grayStars: any[];

  constructor(private router: Router, public dialog: MatDialog,
              private dataService:DataService,
              public utils: UtilsService, private route: ActivatedRoute,
              private authService: AuthService) {
    this.route.params
    .subscribe(
      (params: Params) => {
        this.count = params.count;
      });

    this.route.queryParams
    .subscribe(
      (params: Params) => {
        this.planName = params.planName;
        this.subscriptionsNumber = params.subscriptionsNumber;
        this.subscriptionsPrice = params.subscriptionsPrice;
        this.totalPrice = params.totalPrice;
        this.stars = Array(parseInt(params.stars)).fill(0);
        this.grayStars = Array(7 - parseInt(params.stars)).fill(0);
      });
  }

  buyWithCard() {
    const dialogRef = this.dialog.open(CardBillingComponent,
      {disableClose: true, width: '400px', data: {totalAmount: this.totalPrice, codesCount: this.subscriptionsNumber, plan: this.planName}});
    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'success') {
        this.router.navigate(['/sponsoring'], );
      }
    });
  }

  ngOnInit(): void {
    this.utils.screenTitle.emit({firstTitle: 'Plans and pricing', firstRoute: '/pricing-and-plans',
    secondTitle: 'Billing', secondRoute: '/plan-billing/' + this.count,
    });
  }

  ngAfterViewChecked(): void {
    if (!this.addScript) {
      this.addPaypalScript().then(() => {
        // this.paypalconfig.funding = {disallowed: [ paypal.FUNDING.CREDIT ]};
        paypal.Button.render(this.paypalconfig, '#paypal-checkout-btn');
        this.paypalload = true;
      });
    }
  }

  addPaypalScript() {
    this.addScript = true;
    return new Promise((resolve, reject) => {
      const scripttagelement = document.createElement('script');
      scripttagelement.src = 'https://www.paypalobjects.com/api/checkout.js';
      scripttagelement.onload = resolve;
      document.body.appendChild(scripttagelement);
    });
  }

  paypalBill() {
    const payload = {
      Amount: parseInt(this.totalPrice),
      Currency: 'EUR',
      Description: 'Buy ' + this.subscriptionsNumber + ' sponsors',
      Token: this.transaction.data.paymentID,
      Count: parseInt(this.subscriptionsNumber),
      Type: 1
    };
    this.dataService.post('billing/BillingGateway', payload).then((data) => {
      if (data.statusCode === 200) {
        this.dialog.closeAll();
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Payment done successfully',
            type: 'Success',
            message: 'Your payment has been done successfully, thank you!',
            buttonText: 'Ok'
          }
        });
        this.router.navigate(['/sponsoring'], );
      } else {
        const dialogRef = this.dialog.open(AlertDialogComponent, {
          disableClose: true,
          width: '400px',
          data: {
            title: 'Error',
            type: 'Error',
            message: 'something went wrong, please try again!',
            buttonText: 'Ok'
          }
        });
      }
    });
  }
}
